import React, { useState, useEffect } from 'react'
import Checkbox from '@mui/material/Checkbox'
import Divider from '@mui/material/Divider'
import FormControlLabel from '@mui/material/FormControlLabel'
import Paper from '@mui/material/Paper'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

function FactSourceFirstRow(props) {
    const [headerRow, setHeaderRow] = useState(0)
    const [factSourceFirstRow, setFactSourceFirstRow] = useState(-1)
    const [tabData, setTabData] = useState([])
    const [currentTab, setCurrentTab] = useState(0)
    const [namedColumns, setNamedColumns] = useState(false)
    const [tableHasHeader, setTableHasHeader] = useState(false)

    useEffect(() => {
        setHeaderRow(props.headerRow)
        setTabData(props.previewData)
        setNamedColumns(props.namedColumns)
        setTableHasHeader(props.tableHasHeader)
        setFactSourceFirstRow(props.factSourceFirstRow)
    }, [])

    useEffect(() => {
        if (headerRow === 0 && props.headerRow !== headerRow) {
            setHeaderRow(props.headerRow)
        }
    }, [props.headerRow])

    useEffect(() => {
        if (props.factSourceFirstRow !== factSourceFirstRow) {
            setFactSourceFirstRow(props.factSourceFirstRow)
        }
    }, [props.factSourceFirstRow])

    useEffect(() => {
        if (props.namedColumns !== namedColumns) {
            setNamedColumns(props.namedColumns)
        }
    }, [props.namedColumns])

    useEffect(() => {
        if (props.tableHasHeader !== tableHasHeader) {
            setTableHasHeader(props.tableHasHeader)
        }
    }, [props.tableHasHeader])

    function renderTableOrMessageStatingNothingWasSelected() {
        if (tabData.length > 0) {
            return <Tabs value={currentTab} onChange={(event, newValue) => setCurrentTab(newValue)} aria-label="Preview Data Tabs" variant="scrollable">
                {tabData.map((tab, index) => {return <Tab key={`tab-data-${index}`} label={tab["tabName"]} {...a11yProps(index)} />})}
            </Tabs>
        }

        return null
    }

    function renderSelectedPreviewDataPanel() {
        if (tabData.length > currentTab) {
            return <TableContainer component={Paper} style={{ overflowY: "none", "height":"550px" }}>
                <Table style={{ width: "100%" }} size="small" aria-label="preview data">
                    <TableHead>
                        <TableRow>
                            <TableCell>{' '}</TableCell>
                            {tabData[currentTab].previewData[0].map((tabInfo, tabInfoIndex) => {
                                return <TableCell key={`row-excel-header-${tabInfoIndex}`} align="center">{props.getExcelColumnName(tabInfoIndex + 1)}</TableCell>
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tabData[currentTab].previewData.map((tabInfo, tabInfoIndex) => {
                            return ((tableHasHeader && props.doesThisRowHaveDataInEverySingleColumn(tabInfo)) || !tableHasHeader) ? <TableRow
                                key={`tab-${currentTab}-row-${tabInfoIndex}`}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                style={returnRowColorStandardRow(tabInfoIndex-getTabsRowOffset(tableHasHeader, tabData[currentTab].previewData))}>
                                    <TableCell padding="checkbox">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    color="primary"
                                                    checked={tabInfoIndex-getTabsRowOffset(tableHasHeader, tabData[currentTab].previewData) === factSourceFirstRow}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            let index = tabInfoIndex-getTabsRowOffset(tableHasHeader, tabData[currentTab].previewData)
                                                            setFactSourceFirstRow(index)
                                                            fireOnSaveEvent(index)
                                                        }
                                                    }}
                                                    inputProps={{
                                                        'aria-label': 'select first facts row',
                                                    }}/>
                                            }
                                            label={(tabInfoIndex-getTabsRowOffset(tableHasHeader, tabData[currentTab].previewData))+1}
                                        />
                                    </TableCell>
                                    {renderPreviewRow(tabInfo, tabInfoIndex)}
                            </TableRow> : null
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        }

        return null
    }

    function renderPreviewRow(tabInfo, rowIndex) {
        return tabInfo.map((data, index) => {
            return <TableCell key={`row-${rowIndex}-cell-${index}`} align="center">{data}</TableCell>
        })
    }

    function returnRowColorStandardRow(rowIndex) {
        if (tabData.length > currentTab && factSourceFirstRow === rowIndex && namedColumns) { 
            return { "backgroundColor": props.uiColors.ROW_HIGHLIGHT }
        }
        return { "backgroundColor": props.uiColors.REGULAR }
    }

    /**
     * getTabsRowOffset
     * * 
     * @param {boolean} hasHeader - Do the tables have a header? 
     * @param {Array} tabPreviewData - Preview data from the source 
     * @returns {int} First row header
     */
    function getTabsRowOffset(hasHeader, tabPreviewData) {
        // Only run this if we determine the table has a header
        if (hasHeader) {
            for (let x = 0; x < tabPreviewData.length; x++) {
                if (props.doesThisRowHaveDataInEverySingleColumn(tabPreviewData[x])) {
                    return x
                }
            }
        }

        return 0
    }

    /**
     * fireOnSaveEvent
     * * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} row - Facts First Row
     */
    function fireOnSaveEvent(row) {
        if (props.onSave) {
            props.onSave({ "rowIndex": row })
        }
    }

    return <>
        {factSourceFirstRow > 0 ? <Typography variant="body1">Row {factSourceFirstRow+1} is the first row that contains facts</Typography> : <Typography variant="body1">Facts row not yet defined</Typography>}
        <Divider component="li" />
        {renderTableOrMessageStatingNothingWasSelected()}
        {renderSelectedPreviewDataPanel()}
    </>
}

export default FactSourceFirstRow